import { defineMessages } from 'react-intl-next';

export const i18n = defineMessages({
	positionFilterStatusLabel: {
		id: 'search-page.filters.names.positionStatus',
		defaultMessage: 'Filled status',
		description: 'Label for filtering by position status',
	},
	positionFilterStatusPlaceholder: {
		id: 'search-page.talent.filter.position-status.content.placeholder',
		defaultMessage: 'Find position statuses',
		description: 'Placeholder for position status filter search input',
	},
	positionFilterStatusLabelSelected: {
		id: 'search-page.talent.filter.position-status.content.selected',
		defaultMessage: 'Selected',
		description: 'Position status filter content selected',
	},
	positionFilterStatusLabelUnselected: {
		id: 'search-page.talent.filter.position-status.content.unselected',
		defaultMessage: 'Suggested',
		description: 'Position status filter content unselected',
	},
});
